import React, { useState, useEffect, useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom'
import ReactPaginate from "react-paginate";
function EmployeeListCom() {
  let SERVER_URL = process.env.REACT_APP_API_URL;
  let BASE_URL = process.env.REACT_APP_APP_URL;
  let token = JSON.parse(localStorage.getItem('key'));


  const get_oermission_data = useSelector((state) => state);
  const extract_permissions = get_oermission_data.login_Permission.permissions ? JSON.parse(get_oermission_data.login_Permission.permissions) : '';
  const hr_permission = get_oermission_data.login_Permission.permissions

  const pagination = useRef();
  const [searchemail, setSearchemail] = useState('');
  const [emplist, setEmplist] = useState([]);
  const [perPage, setPerpage] = useState('');
  const [totalitem, setTotalitem] = useState('');
  const [searchbytext, setSearchbytext] = useState('');
  const [dept, setDept] = useState([]);
  const [deptid, setDeptid] = useState('');
  const [skill, setSkill] = useState('');
  const [skillsList, setSkillsList] = useState([]);
  const [page_Number, setPage_Number] = useState(1);
  const setPage = ({ selected }) => {
    getuserlist(searchbytext, selected + 1, deptid, skill)
  }
  useEffect(() => {
    getuserlist(searchbytext, page_Number, deptid, skill)
    getDepartment()
    get_skills_list()
  }, [])
  const get_skills_list = async () => {
    const response = await fetch(SERVER_URL + `api/common/skills_list`,
      {
        method: 'GET',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'authorization': `bearer ${token.value}`
        },
      }).then(res => res.json())
      .then(data => {
        setSkillsList(data.result)
      })
  }

  const getDepartment = async () => {
    const response = await fetch(SERVER_URL + `api/common/department_list`,
      {
        method: 'GET',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'authorization': `bearer ${token.value}`
        },
      }).then(res => res.json())
      .then(data => {
        setDept(data.result)
      })
  }

  const getuserlist = async (textsearch, pagenumber, dept_id) => {
    const response = await fetch(SERVER_URL + `api/employee?query=${textsearch}&page=${pagenumber == 'undefined' ? 1 : pagenumber}&department=${dept_id}&skill=${skill}`,
      {
        method: 'GET',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'authorization': `bearer ${token.value}`
        },
      })
      .then(res => res.json())
      .then(data => {
        setEmplist(data.users)
        setTotalitem(data.Emptotal[0].Total);
        setPerpage(data.limit)
      });
  }


  const Search_filter = () => {
    getuserlist(searchbytext, page_Number, deptid, skill)
  }
  const Reset_filter = () => {
    setSearchbytext('');
    setPage_Number(1);
    setDeptid("");
    setSkill("");
    getuserlist('', 1, '', '')
  }
  return (
    <>
      <div className="page-header">
        <h1>
          {
            hr_permission?.includes('26') && (<Link className="btn_5 mr10 float-end" to='/addemployee'>Add Employee</Link>)
          }

          Employee
        </h1>
        <ul id="breadcrumbs" className="breadcrumb mb00">
          <li>
            <Link to="/dashboard">Dashboard </Link>
          </li>
          <li className="current">
            <span>/</span> Employee
          </li>
        </ul>
      </div>
      <div className="row_bg">
        <div className="dash_white_box2 mb20 p20">
          <div className="dash_white_box_ttl">Search</div>
          <div className="row mb10">
            <div className="col-lg-3 col-md-6 pr07">
              <label className="form-label">Employee Name / Code</label>
              <input type="text" className="form-control" onChange={(e) => setSearchbytext(e.target.value)} value={searchbytext} autoComplete='none' placeholder='Search by name' />
            </div>
            <div className="col-lg-3 col-md-6 pl07 pr07">
              <label className="form-label">Department</label>
              <div className="form-input">
                <select onChange={e => setDeptid(e.target.value)} value={deptid} className="form-select">
                  <option value=''>Select Department </option>
                  {
                    dept?.map((item, ind) => {
                      return <option key={ind + 1} value={item.id}>{item.name}</option>
                    })
                  }
                </select>
              </div>
            </div>
            <div className="col-lg-3 col-md-6 pl07 pr07">
              <label className="form-label"> Skills</label>
              <div className="form-input">
                <select value={skill} className="form-select" onChange={e => { setSkill(e.target.value) }}>
                  <option value=''>Select Skills </option>
                  {
                    skillsList.map((item, ind) => {
                      return <option value={item.id}>{item.name}</option>
                    })
                  }
                </select>
              </div>
            </div>
            <div className="col-lg-3 col-md-6 pr07">
              <label className="h49 mb10"></label>
              <button onClick={Search_filter} className="btn_5 mr08">Search</button>
              <button onClick={Reset_filter} className="btn_6">Reset</button>
            </div>
          </div>
        </div>
        <div className="row mb30">
          <div className="col-md-12">
            <table className="table_style_1">
              <thead>
                <tr>
                  <th>Employee Code</th>
                  <th>Employee Name</th>
                  <th>Department </th>
                  <th>Designation	</th>
                  <th>Employee Type</th>
                  <th>Contact</th>
                  <th style={{ width: "140px" }}>Action</th>
                </tr>
              </thead>
              <tbody>
                {emplist?.map((item, ind) => {
                  return <tr key={ind}>
                    <td>{item.user_code ? item.user_code : ''}</td>
                    <td><span className="avatar_icon">{item.name ? item.name.match(/(\b\S)?/g).join("").match(/(^\S|\S$)?/g).join("").toUpperCase() : ''}</span>{item.name}</td>
                    <td>{item.dept_name}</td>
                    <td>{item.role_name}</td>
                    <td>Inhouse</td>
                    <td>{item.contact_no ? item.contact_no : ''}</td>
                    <td>
                      {
                        hr_permission?.includes('28') && (<button className="btn_5 mr03">View</button>)
                      }
                      {
                        hr_permission?.includes('27') && (<Link to={`/editemployee?id=${+item.id}`} className="btn_7">Edit</Link>)
                      }

                    </td>
                  </tr>
                })}
              </tbody>
              <tfoot>
                <tr><td colSpan="8" >
                  <span onClick={e => pagination.current.setState({ selected: 10 - 1 })} ></span>
                  <ReactPaginate
                    ref={pagination}
                    pageCount={Math.ceil(totalitem / perPage)}
                    pageRangeDisplayed={4}
                    marginPagesDisplayed={1}
                    onPageChange={setPage}
                    containerClassName="pagination"
                    activeClassName="active"
                    pageLinkClassName="page-link"
                    breakLinkClassName="page-link"
                    nextLinkClassName="page-link"
                    previousLinkClassName="page-link"
                    pageClassName="page-item"
                    breakClassName="page-item"
                    nextClassName="page-item"
                    previousClassName="page-item"
                    previousLabel={<>&laquo;</>}
                    nextLabel={<>&raquo;</>}
                  />
                </td></tr>
              </tfoot>
            </table>
          </div>
        </div>
      </div>
    </>
  )
}

export default EmployeeListCom
